import React from 'react';
import { Box, Button, Typography } from '@mui/material';

// COMPONENTS
import CustomModal from '../CustomModal';

const ErrorModal = ({
  errorStack,
  showError,
  removeError,
  windowLocation,
  resetWindowLocation,
}) => {
  if (window.location.pathname !== windowLocation) {
    resetWindowLocation();
    return null;
  }

  if (errorStack !== undefined) {
    // handles error stack
    if (Array.isArray(errorStack) && errorStack.length === 0) return null;
    if (typeof errorStack !== 'string')
      errorStack =
        errorStack.message ||
        'FAILURE: Pass string to error handler, not object.';

    return (
      <CustomModal
        open={showError}
        handleClose={() => removeError()}
        title="Error"
        type="error"
      >
        <Box sx={{ marginTop: 2, marginBottom: 4 }}>
          <Typography>{errorStack}</Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
          <Button
            variant="contained"
            color="error"
            onClick={() => removeError()}
          >
            Close
          </Button>
        </Box>
      </CustomModal>
    );
  } else {
    console.log('error not being caught properly');
    return null;
  }
};

export default ErrorModal;
